import { useSortManager } from '../sortManager'

export const useGetCheapestQuickestCard = () => {
    const { sortOptions } = useSortManager()

    const cheapestQuickestOptions = sortOptions.filter(option => option.id === 'cheapest' || option.id === 'quickest')

    // Group options by card ID
    const cardGroups = new Map<string, typeof cheapestQuickestOptions>()

    cheapestQuickestOptions.forEach(option => {
        const cardId = option.card?.id
        if (cardId) {
            if (!cardGroups.has(cardId)) {
                cardGroups.set(cardId, [])
            }
            cardGroups.get(cardId)!.push(option)
        }
    })

    // Process each group
    const result = Array.from(cardGroups.values()).map(group => {
        if (group.length === 1) {
            // Single option, return as is
            return group[0]
        } else {
            // Multiple options pointing to same card, combine them
            const combinedOption = {
                id: group.map(opt => opt.id).join('_'),
                label: group.map(opt => opt.label).join('_'),
                priceAndDuration: group.map(opt => opt.priceAndDuration).join('_'),
                sortKey: group.map(opt => opt.sortKey).join('_'),
                isActive: group.some(opt => opt.isActive),
                card: group[0].card, // All have same card, so take first one
                isCombined: true
            }

            return combinedOption
        }
    })

    // Sort by isActive first (active cards come first)
    return result.sort((a, b) => {
        if (a.isActive && !b.isActive) return -1
        if (!a.isActive && b.isActive) return 1
        // If both have same isActive status, maintain original order
        return 0
    })
}
